import { Router, type IRouter } from "express";
import healthRouter from "./health";
import authRouter from "./auth";
import dealsRouter from "./deals";
import accessRequestsRouter from "./access-requests";
import paymentsRouter from "./payments";
import adminRouter from "./admin";
import usersRouter from "./users";
import sellerLeadsRouter from "./seller-leads";
import aiRouter from "./ai";
import dealRoomsRouter from "./deal-rooms";

const router: IRouter = Router();

router.use(healthRouter);
router.use(authRouter);
router.use(dealsRouter);
router.use(accessRequestsRouter);
router.use(paymentsRouter);
router.use(adminRouter);
router.use(usersRouter);
router.use(sellerLeadsRouter);
router.use(aiRouter);
router.use(dealRoomsRouter);

export default router;
